module.exports = __webpack_public_path__ + "img/fawLogo.cd05a2d1.png";